import { render, staticRenderFns } from "./RankingPage.vue?vue&type=template&id=60256ce5&scoped=true"
import script from "./RankingPage.vue?vue&type=script&lang=js"
export * from "./RankingPage.vue?vue&type=script&lang=js"
import style0 from "./RankingPage.vue?vue&type=style&index=0&id=60256ce5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60256ce5",
  null
  
)

export default component.exports